import type { InquiryInput } from "@mizpah/shared";

// Same-origin by default: CloudFront routes /api/* to the API Gateway origin.
const API_URL = (import.meta.env.VITE_API_URL ?? "/api").replace(/\/$/, "");

export interface ApiError {
  message: string;
  fields?: Record<string, string>;
}

export class RequestError extends Error {
  constructor(public status: number, public api: ApiError) {
    super(api.message);
  }
}

export interface InquiryResult {
  prospectId: string;
  emailStatus: "sent" | "failed";
  /** Public link to the selected course's current brochure; "" if none uploaded. */
  brochureUrl?: string;
}

/** POST the contact form to the inquiry pipeline. */
export async function submitInquiry(input: InquiryInput): Promise<InquiryResult> {
  const res = await fetch(`${API_URL}/inquiries`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) {
    const err = (data.error ?? { message: "Something went wrong" }) as ApiError;
    throw new RequestError(res.status, err);
  }
  return data as unknown as InquiryResult;
}
